import { render, staticRenderFns } from "./GameListPage.vue?vue&type=template&id=b598684c"
import script from "./GameListPage.vue?vue&type=script&lang=js"
export * from "./GameListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports